import React from "react";

import "./index.scss";

interface SensorsChartLegendProps {
  items: { name: string; type: "line" | "circle" | "dash-dot"; color: string }[];
}

const SensorsChartLegend = (props: SensorsChartLegendProps) => {
  const { items } = props;
  return (
    <div className="sensors-chart-legend">
      {items.map((item) => (
        <div className="legend-item" key={item.name}>
          <div style={{ background: item.color }} className={`legend-type ${item.type}`} />
          <div className="legend-name">{item.name}</div>
        </div>
      ))}
    </div>
  );
};

export default SensorsChartLegend;
